import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import BadgesComponent from '../../../../../components/common/Badges';
import './overview.css';
import CoverageCardViewComponent from '@components/common/CoverageCardView';
import dayjs from 'dayjs';
import { overViewType } from '../../vhnd-interface';
import FacilityESRIMap from '@components/common/Esrimap/MapWrapper';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { page_type } from '@constants/esriMapConstant';
import { dateFormate } from '@constants/index';
import config from '@config/config';

const VhndUhndOverview = (props: overViewType) => {
  const { sessionDetail, flow } = props;

  const location = useRef({ latitude: (sessionDetail && sessionDetail?.session_latitude) ? sessionDetail?.session_latitude : '', longitude: (sessionDetail && sessionDetail?.session_longitude) ? sessionDetail?.session_longitude : '' });
  const dtCode = useRef({ dtCode: (sessionDetail && sessionDetail.dist_code) ? `${sessionDetail?.dist_code}` : '' });
  const coverageAreaCoordinates = useRef<any[]>([]);
  const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);
  const facilityGeoMapref = useRef(facilityGeoMap);
  const [mapRender, setMapRender] = useState(false);

  useEffect(() => {
    facilityGeoMapref.current = facilityGeoMap;
  }, [facilityGeoMap]);

  const onCreateCoverageAreaPolygone = useCallback(() => {
    if (!facilityGeoMapref.current.mapServicesDown) {
      const coverageAreaData: any[] = JSON.parse(JSON.stringify(sessionDetail?.coverage_area));
      const coordinates: any[] = [];
      coverageAreaData?.forEach((element: any) => {
        coordinates.push(element?.coverage_lat_long);
      });
      coordinates.push(coverageAreaData?.[0]?.coverage_lat_long);
      coverageAreaCoordinates.current = coordinates;
      location.current = { latitude: (sessionDetail && sessionDetail?.session_latitude) ? sessionDetail?.session_latitude : '', longitude: (sessionDetail && sessionDetail?.session_longitude) ? sessionDetail?.session_longitude : '' };
      setMapRender(!mapRender);
    }
  }, []);

  useEffect(() => {
    onCreateCoverageAreaPolygone()
  }, []);

  const formatLinkedFacility = (data: any, type: string) => {
    const arrayData = (data && data.length > 0) ? data : [];
    if (type === 'village_coverage') {
      return arrayData.map((item: any) => ({
        id: item.village_id,
        name: item.village_name + " - " + item.village_code,
        code: item.village_code,
      }));
    }
    else if (type === 'ward_coverage') {
      return arrayData.map((item: any) => ({
        id: item.ward_id,
        name: item.ward_name + " - " + item.ward_code,
        code: item.ward_code,
      }));
    } else if (type === 'coverage_area') {
      return arrayData.map((item: any, index: any) => ({
        id: index,
        name: item?.coverage_area,
        code: item?.coverage_area
      }));
    }
    else {
      return [];
    }
  }

  return (
    <>
      <div className="overview_session">
        <BadgesComponent
          className="over-badge"
          badgeName="Session Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div className={`${'session_type_name'}_wrapper`}>
            <label className="overview-details-label">Session type</label>
            <div className="overview-details-value">
              {sessionDetail?.session_type_name || "-"}
            </div>
          </div>
          <div className={`${'session_name'}_wrapper`}>
            <label className="overview-details-label">Session Name</label>
            <div className="overview-details-value">
              {sessionDetail?.session_name || "-"}
            </div>
          </div>
          <div className={`${'session_planned_date'}_wrapper`}>
            <label className="overview-details-label">Session Date</label>
            <div className="overview-details-value">
              {dayjs(sessionDetail?.session_planned_date).format(dateFormate.dd_mm_yyyy) || "-"}
            </div>
          </div>
          <div className={`${'state_name'}_wrapper`}>
            <label className="overview-details-label">State</label>
            <div className="overview-details-value">
              {sessionDetail?.state_name || "-"}
            </div>
          </div>
          <div className={`${'dist_name'}_wrapper`}>
            <label className="overview-details-label">District</label>
            <div className="overview-details-value">
              {sessionDetail?.dist_name || "-"}
            </div>
          </div>
          <div className={`${'facility_name'}_wrapper`}>
            <label className="overview-details-label">Facility</label>
            <div className="overview-details-value">
              {sessionDetail?.facility_name || "-"}
            </div>
          </div>
          <div className={`${'session_held_at_name'}_wrapper`}>
            <label className="overview-details-label">Session Held at</label>
            <div className="overview-details-value">
              {sessionDetail?.session_held_at_name || "-"}
            </div>
          </div>
          <div className={`${'session_site_address'}_wrapper`}>
            <label className="overview-details-label">
              Session Site Address
            </label>
            <div className="overview-details-value">
              {sessionDetail?.session_site_address || "-"}
            </div>
          </div>

          <div className={`${'health_provider_tagged'}_wrapper`}>
            <label className="overview-details-label">
              Health Provider Tagged
            </label>
            <div className="overview-details-value">
              {sessionDetail?.health_provider_tagged?.map((hp: any) => `${hp.health_provider_f_name} ${hp.health_provider_l_name}`).join(', ') || "-"}
            </div>
          </div>
          <div className={`${'mobiliser_tagged'}_wrapper`}>
            <label className="overview-details-label">Mobiliser Tagged</label>
            <div className="overview-details-value">
              {sessionDetail?.mobiliser_tagged?.map((mt: any) => `${mt.mobiliser_f_name} ${mt.mobiliser_l_name}`).join(', ') || "-"}
            </div>
          </div>
          <div className={`${'status'}_wrapper`}>
            <label className="overview-details-label">Session Status</label>
            <div className="overview-details-value">
              {sessionDetail?.session_status_name || "-"}
            </div>
          </div>
        </div>
      </div >
      <div className="overview_session">
        <BadgesComponent
          className="over-badge"
          badgeName="Session Coverage"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details-coverage">

          {mapRender && <div className={`map_wrapper`}>
            <FacilityESRIMap
              latitude={location.current.latitude}
              longitude={location.current.longitude}
              dtCode={dtCode.current}
              mapRender={mapRender}
              pageType={page_type.session_site_vhnd}
              coverageAreaCoordinates={coverageAreaCoordinates.current}
            />
            <div className="attributionNotes">
              Powered By <img src={`${config.root ? config.root : ''}/assets/images/NicBharatMaps.png`} alt="NicBharatMaps" style={{height:40}}/>
            </div>
          </div>}

          <div className={`${'village_coverage'}_wrapper`}>
            <div className="overview-details-value">
              <CoverageCardViewComponent listItems={formatLinkedFacility(sessionDetail?.village_coverage, 'village_coverage')}
                labelforCoverage={'Villages Covered'} colorCode={'#2b2b2b'} />
            </div>
          </div>

          <div className={`${'ward_coverage'}_wrapper`}>
            <div className="overview-details-value">
              <CoverageCardViewComponent listItems={formatLinkedFacility(sessionDetail?.ward_coverage, 'ward_coverage')}
                labelforCoverage={'Wards Covered'} colorCode={'#2b2b2b'} />
            </div>
          </div>

          <div className={`${'coverage_area'}_wrapper`}>
            <div className="overview-details-value">
              <CoverageCardViewComponent listItems={formatLinkedFacility(sessionDetail?.coverage_area, 'coverage_area')}
                labelforCoverage={'Coverage Area'} colorCode={'#2b2b2b'} />
            </div>
          </div>

        </div>
      </div >
    </>
  );
};

const MemoizedSessionDetailsOverView = memo(VhndUhndOverview);
MemoizedSessionDetailsOverView.displayName = "VhndUhndOverview"

export default MemoizedSessionDetailsOverView;
